import {http} from '@/utils/request';

export interface CryptoCoin {
  addressRegex: string;
  code: string;
  logo: string;
  name: string;
  network: string;
}

export interface CryptoWithdrawalParams {
  /**
   * 加密货币支付地址
   */
  payAddress: string;
  /**
   * 提现金额
   */
  amount: number;
  /**
   * 支付货币
   */
  payCurrency: string;
}

export interface PayConfig {
  /**
   * 加密货币最小提现金额
   */
  cryptoWithdrawalAmount: number;
  /**
   * 加密货币提现金额限制
   */
  cryptoWithdrawalAmountLimit: number;
  /**
   * 加密货币提现手续费
   */
  cryptoWithdrawalFee: number;
  /**
   * 汇率
   */
  exchange: number;
  /**
   * 加密货币充值手续费
   */
  cryptoRechargeFee: number;
  /**
   * 提现次数
   */
  withdrawalCount?: number | string;
}

/**
 * 获取加密货币列表
 */
export const getCryptoCoinList = () => {
  return http.post<null, CryptoCoin[]>('app/pay/crypto/coin/list');
};

/**
 * 加密货币提现
 */
export const postCryptoWithdrawal = (params: CryptoWithdrawalParams) => {
  return http.post<CryptoWithdrawalParams, any>('app/pay/crypto/paid', params);
};

/**
 * 获取支付相关配置
 */
export const getPayConfig = () => {
  return http.post<null, PayConfig>('app/pay/config');
};
